const parseQueryStrings = (qs)=>{
    if (!qs) return;
    const queryStrings = qs.replace('?', '').split('&');
    const parsedObject = {};
    queryStrings.forEach((q)=>{
        const [key, ...rest] = q.split('=');
        const value = rest.length > 1 ? rest.join('=') : rest[0];
        if (key) parsedObject[key] = value || true;
    });
    return parsedObject;
};
const src_parseQueryStrings = parseQueryStrings;
export default src_parseQueryStrings;
export { parseQueryStrings };
